class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if(!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, drawerOpen = true) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      
      if(!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    const observer = new MutationObserver((mutations) => {
      let container = document.querySelector("#container-recommended-products-desktop");
      if (container && container.children.length >= 3) {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        if(drawerOpen){
          this.open();
        }
        
        // Disconnect the observer once we've found what we need
        observer.disconnect();
      }
    });

    observer.observe(document.body, { 
      childList: true,
      subtree: true
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  //Created this function to easily refresh cart-drawer and cart-bubble
  async refresh(shouldDrawerOpen = false, source = null) {
    try {        
      const response = this.getSectionsToRender().map((section) => section.id);
      const cartResponse = await fetch(`?sections=${response.join(',')}`);
      const sections = await cartResponse.json();
  
      let ADDTOCART_OBJECT = { sections: sections }
      
      // Store a reference to determine if cart is empty
      // Make a separate call to get the cart data
      const cartDataResponse = await fetch('/cart.js');
      const cartData = await cartDataResponse.json();
      const isCartEmpty = cartData.item_count === 0;

      // Use provided source or default to 'cart-drawer'
      const eventSource = source || 'cart-drawer';
      publish(PUB_SUB_EVENTS.cartUpdate, { source: eventSource });
      
      // put some delay ti make the dom is completely loaded
      await new Promise(resolve => setTimeout(resolve, 50));
      await new Promise(requestAnimationFrame);

      // Render contents
      this.renderContents(ADDTOCART_OBJECT, false);
      
      // Make sure the overlay is clickable by adding the close event listener
      const newOverlay = document.querySelector('.cart-drawer__overlay');
      if (newOverlay) {
        newOverlay.addEventListener('click', () => {
          if (typeof this.close === 'function') {
            this.close();
          } else {
            this.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
          }
        });
      }
      
      // Handle empty cart state properly
      if (isCartEmpty) {
        this.classList.add('is-empty');
      } else {
        if (this.classList.contains('is-empty')) this.classList.remove('is-empty');
      }

      if(shouldDrawerOpen) {
        this.open();
      }

      return { success: true};

    } catch (error) {
      // console.log('Failed to refresh the cart!', error);
      return { success: false};
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
